function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "61.52 50.77 56.24 56.05 56.24 14 51.24 14 51.24 56.28 45.74 50.77 42.2 54.31 53.63 65.73 65.06 54.31 61.52 50.77"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M22.2,14l-7.26,21.16v2.84h5v-1.91l.72-2.09h7.04l.72,2.09v1.91h5v-2.84l-7.26-21.16h-3.96ZM22.37,29.03l1.81-5.29,1.81,5.29h-3.63Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "15.49 48 27.13 48 15.24 60.21 15.24 66 33 66 33 61 21.36 61 33.24 48.79 33.24 43 15.49 43 15.49 48"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/Name.b40dec14.svg";
export { SvgComponent as ReactComponent };